import React from 'react';
import {View, Text} from 'tamagui';
import styles from '@stylesheet';
import ComponentRenderer from './ComponentRenderer';
import defaultValComponents, { ValidationComponentType } from '../utils/defaultValComponents';
import { ValidationType } from '../types/validatorTypes';

const DataSetValidation = ({item, index}: ValidationType) => {
  const validationComponents: ValidationComponentType[] = [
    ...defaultValComponents,
    { key: 'dataSetId', label: 'Data Set', type: 'dataSetSelection' },
  ];

  return (
    <View style={[styles.validationView, { flexWrap: 'wrap' }]}>
      {validationComponents.map((component) => (
        <View key={component.key} style={{ flexDirection: 'row', alignItems: 'center', alignSelf: 'stretch', position: 'relative', flexWrap: 'wrap' }}>
          {
            component.type === 'switch' &&
            <Text style={{ flex: 1 }}>{component.label}</Text>
          }
          <ComponentRenderer item={item} component={component} index={index} />
        </View>
      ))}
    </View>
  );
}
export default DataSetValidation;